<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 考级测试</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="warning" class="elalert">
        1.请根据自己的身份选择不同的考试类型<br />
        2.游客身份可以测试客观题，不可以测试实践题。<br />
        3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。<br />
      </el-alert>

      <el-steps
        :space="200"
        :active="4"
        finish-status="success"
        class="elsteps"
      >
        <el-step title="报名信息"></el-step>
        <el-step title="理论测试"></el-step>
        <el-step title="实践考试"></el-step>
        <el-step title="考级结果"></el-step>
        <el-step title="查看证书"></el-step>
      </el-steps>

      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="row.user.face" />
            </div>
            <div class="container_left_content_name">
              <span>姓名：</span>{{ row.user.name }}
            </div>
            <div class="container_left_content_name">
              <span>实践题：</span>《实践题题目》
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                @click="serviceCustomerClickFun()"
                :style="{ color: '#1981ff' }"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>
        <div class="container_center" v-if="row.status == 5">
          <div class="container_center_upsuccess">
            <i class="el-icon-success"></i>上传成功
          </div>
          <div class="container_center_des">
            等候评委在7个工作日内的审核，最终考试结果，将在您的考级申报窗口显示并同时用站内信箱显示，祝您成功！
          </div>
          <div class="container_center_goback">
            <el-button type="primary" plain="" v-rblink="{ path: '/indexpc' }"
              >返回首页</el-button
            >
          </div>
        </div>
        <div class="container_center" v-else-if="row.status == 6">
          <div class="container_center_upsuccess">
            <i class="el-icon-success"></i>考级成功
          </div>
          <div class="container_center_des">
            经专家评审，恭喜您考级顺利过关，获得“{{
              row.grade
            }}”级别。请查看您的电子证书。
          </div>
          <div class="container_center_goback">
            <el-button
              type="primary"
              :disabled="!cert.url"
              @click="dialogVisible = true"
              plain=""
              >查看证书</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="查看证书" :visible.sync="dialogVisible">
      <img style="width: 100%" :src="cert.url" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="download">下载打印证书</el-button>
        <el-button type="primary" @click="goPost">申请原件</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import NewsListItem from "@/components/listItem/NewsListItem";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      dialogVisible: false,
      row: {
        id: 0,
        user: {},
        kaoji: {},
      },
      cert: {
        url: "",
      },
    };
  },
  components: {},
  computed: {},
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id || 0;
    if (that.row.id) {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post(
        "/api/kaoji/step5Detail",
        {
          id: that.row.id,
        },
        (res) => {
          that.row = res.data;
        }
      );

      that.$api.post(
        "/api/kaoji/getCert",
        {
          id: that.row.id,
        },
        (res) => {
          that.cert = res.data;
        },
        (res) => {}
      );
    },
    goPost() {
      let that = this;
      this.$router.push({
        name: "KaojiApplyPost",
        query: {
          id: that.row.id,
        },
      });
    },
    download() {
      window.open(
        window.apiRoot +
          "/api/index/dlf?name=" +
          this.cert.filename +
          "&url=" +
          encodeURIComponent(this.cert.url)
      );
    },
  },
};
</script>
<style scoped lang="scss">
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1000px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 74px 0 0 0;
    .container_center_upsuccess {
      font-size: 24px;

      font-weight: 400;
      color: #e02020;
      display: flex;
      flex-direction: row;
      align-items: center;
      .el-icon-success {
        font-size: 40px;
        margin-right: 24px;
        color: #47c556;
      }
    }
    .container_center_des {
      width: 641px;
      height: 66px;
      font-size: 24px;

      font-weight: 400;
      color: #666666;
      line-height: 33px;
      margin: 56px 0 230px 0;
    }
    .container_center_goback {
      .el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
      }
    }
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// KaojiApplyStep6.vue?c3911ae6